import React, {Component} from 'react';
import {Footer, NavBar, Session} from "../../components";
import {VIEW_NAME, config} from "../../libs/utils/Const";

class ContactUsView extends Component {
    render() {
        const {history} = this.props;
        const { locations } = config.contactUs;
        return (
            <div className="content-fluid" style={{marginTop: 100,backgroundColor:"#FFFFFF"}}>
                <Session history={history} view={VIEW_NAME.CONTACT_US_VIEW}/>
                <NavBar/>
                <div className="bannerRedCompensas margenS">
                    <img id = "scrollDownPlease" className="img-fluid"
                        src={require('../../images/brival/HOME/contacto.png')}
                        alt="Segundo NavBar"
                    />
                </div>
                <div className="container" style={{ marginTop: 20, minHeight: '80vh'}}>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="list-group" id="list-tab" role="tablist">
                                {locations.map( (location, index) => {
                                    return  <a key={index} className={"list-group-item list-group-item-action " + (!index ? 'active' : '')} id={"list" + index} style={{color: config.contactUs.colorOSGA}}data-toggle="list" href={"#location" + index}>
                                        { location.name }
                                    </a>
                                })}
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="tab-content" id="nav-tabContent">
                                {locations.map( (location, index) => {
                                    return  <div key={index} className={"tab-pane fade" + (!index ? ' show active' : '')} id={"location" + index} role="tabpanel" montserrat-labelledby={"list" + index}>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item">
                                                <i className={ config.icons.road } style={{color: config.contactUs.iconColor, margin: 5}}> </i>
                                                { location.street }
                                            </li>
                                            <li className="list-group-item">
                                                <i className={ config.icons.city } style={{color: config.contactUs.iconColor, margin: 5}}> </i>
                                                { location.country }
                                            </li>
                                            <li className="list-group-item">
                                                <i className={ config.icons.phone } style={{color: config.contactUs.iconColor, margin: 5}}> </i>
                                                { location.phone }
                                            </li>
                                            {/* <li className="list-group-item correo">
                                                <a target="_blank" href={"mailto:" + location.email}>
                                                    <i className={ config.icons.envelope } style={{color: config.contactUs.iconColor, margin: 5}}> </i>
                                                    { location.email }
                                                </a>
                                            </li> */}
                                            <li className="list-group-item">
                                                <i className={ config.icons.pin } style={{color: config.contactUs.colorOSGA}}> </i>
                                                <a target="_blank" href={ location.maps } style={{color: config.contactUs.colorOSGA}}>
                                                    Ir a Google Maps
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }
}

export default ContactUsView;